import { Alert, Button, Input } from '30pay/components';
import { Radio } from 'antd';
import { NetworksApiResponse, NetworksTypes } from 'interfaces';
import { useEffect, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { get } from 'scripts';
import { Card } from 'utilities/components';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { ConvertBoxDataType } from '../../convertBox.index';
import { API } from 'data/30pay.api';
import { SelectNetworkModal } from '../modal/selectNetworksModal.index';
import { __TypeOfOrderEnum } from '../..//initial/initial.interface';
import {
    __BuyCryptoWithdrawMethodConvertBoxProps,
    __BuyCryptoWithdrawMethodsEnums,
} from './buyCryptoWithdrawMethod.interface';

const BuyCryptoWithdrawMethod: React.FC<__BuyCryptoWithdrawMethodConvertBoxProps> = (
    props: __BuyCryptoWithdrawMethodConvertBoxProps,
) => {
    const [withdrawMethod, setWithdrawMethod] = useState<__BuyCryptoWithdrawMethodsEnums>(
        __BuyCryptoWithdrawMethodsEnums.direct,
    );
    const [networksLoading, setNetworksLoading] = useState(true);
    const [networks, setNetworks] = useState<NetworksTypes[]>();
    const [selectedNetwork, setSelectedNetwork] = useState<NetworksTypes>();
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [walletAddress, setWalletAddress] = useState<string | undefined>();
    const [addressError, setAddressError] = useState<string>('');

    useEffect(() => {
        setNetworksLoading(true);
        const isSell = props.data?.typeOfOrder === __TypeOfOrderEnum.sell;
        const targetCoin = isSell ? props.data?.srcCoin?.symbol : props.data?.destCoin?.symbol;
        if (targetCoin) {
            get<NetworksApiResponse>(API.market.networks(targetCoin.toLowerCase(), isSell))
                .then((e) => {
                    const networks = e.value.value.networks;
                    setNetworks(networks);
                    setSelectedNetwork(networks[0]);
                })
                .catch((e) => console.log(e))
                .finally(() => setNetworksLoading(false));
        } else {
            setNetworksLoading(false);
            setNetworks([]);
        }
    }, []);

    useEffect(() => {
        if (selectedNetwork?.addressRegex && walletAddress) {
            const regex = new RegExp(selectedNetwork.addressRegex);
            if (!regex.test(walletAddress)) {
                setAddressError('آدرس کیف پول وارد شده معتبر نیست');
            } else {
                setAddressError('');
            }
        } else {
            setAddressError('');
        }
    }, [selectedNetwork, walletAddress]);

    function submitHandler() {
        const output: ConvertBoxDataType = {
            network: selectedNetwork,
            walletAddress,
        };
        props.onSubmit(output);
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            {networks && (
                <SelectNetworkModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    networks={networks}
                    onSelect={(network: any) => {
                        setSelectedNetwork(network);
                        setModalOpen(false);
                    }}
                />
            )}
            <Card loading={networksLoading} className="flex-1" title="روش دریافت" titleDivider>
                <div className="flex flex-col gap-6">
                    <Radio.Group
                        buttonStyle="solid"
                        onChange={(e) => setWithdrawMethod(e.target.value)}
                        value={withdrawMethod}
                    >
                        <Radio value={__BuyCryptoWithdrawMethodsEnums.direct}>برداشت مستقیم</Radio>
                    </Radio.Group>

                    <div className="flex flex-col gap-2">
                        <label className={'max-lg:text-sm'}>انتخاب شبکه :</label>
                        <div
                            onClick={() => setModalOpen(true)}
                            className={
                                'flex justify-between items-center border border-primary-40 rounded-[28px] text-base px-6 h-14 max-lg:h-12 max-lg:text-sm mt-2 clickable'
                            }
                        >
                            {!networksLoading &&
                                (selectedNetwork ? (
                                    <>
                                        <div className={'flex items-center gap-4 en'}>{selectedNetwork?.name}</div>
                                        <BsChevronDown />
                                    </>
                                ) : (
                                    <p className="text-sm mx-auto font-medium text-darkPurple-40">
                                        برای انتخاب شبکه مورد نظر کلیک کنید
                                    </p>
                                ))}
                        </div>
                    </div>
                    <div className="gap-2 flex flex-col">
                        <label className="font-bold text-base text-black-100">آدرس مقصد:</label>
                        <Input
                            className={walletAddress && walletAddress !== '' ? 'en' : ''}
                            value={walletAddress}
                            onChange={(e) => setWalletAddress(e.target.value)}
                            placeholder="آدرس مقصد خود را وارد کنید"
                            status={addressError ? 'error' : undefined}
                        />
                        {addressError && <span className="text-red-500 text-sm">{addressError}</span>}
                    </div>
                </div>
                <div className="flex items-center w-full gap-4 mt-6">
                    <Button
                        disabled={
                            !selectedNetwork ||
                            !walletAddress ||
                            walletAddress === '' ||
                            props.loading ||
                            !!addressError
                        }
                        onClick={submitHandler}
                        className="w-full h-16"
                        type="primary"
                        loading={props.loading}
                    >
                        <HiArrowRight />
                        ادامه
                    </Button>
                    <Button onClick={backHandler} className="w-full h-16 bg-background" type="text">
                        بازگشت
                        <HiArrowLeft />
                    </Button>
                </div>
            </Card>
            <div className="flex flex-col gap-6 flex-1">
                <Alert
                    title="روش شارژ کیف پول:"
                    message="در این روش پس از پرداخت، ارز به صورت خودکار به کیف پول موجود در پنل کاربری شما اضافه خواهد شد."
                    variant="info"
                />
                <Alert
                    title="روش شارژ مستقیم:"
                    message="در این روش پس از وارد کردن لینک کیف پول رمزارز خود،ارز مقصد را دریافت می کنید"
                    variant="info"
                />
            </div>
        </div>
    );
};
export default BuyCryptoWithdrawMethod;
